export default __webpack_public_path__ + "static/featured-properties-img3-4d729ade44625e7c8a594f93ff3de725.jpg";